import { truncateSync } from "fs";
import { LineData } from "lightweight-charts";
import { DGDrawingServiceGlobal } from "../Services/DrawingService";
import { LoggerService } from "../Services/Logger/Logger";
import { MagnituderAlertsService } from "../Services/MagnituderAlertsService";

export class MagnituderAlerts {
  public lastArray: LineData[] = [];
  public currentArray: LineData[] = [];
  public canCheckSignal = false;
  public currentState: SignalStates;
  public lastState: SignalStates;
  public buyAudio: HTMLAudioElement;
  public sellAudio: HTMLAudioElement;
  public isAlertActive: boolean = true;
  constructor(public magnituderAlerts: MagnituderAlertsService) {

    try {
      this.buyAudio = new Audio();
      this.sellAudio = new Audio();

      this.buyAudio.src = "bear3.wav";
      this.buyAudio.load();

      this.sellAudio.src = "bull.mp3";
      this.sellAudio.load();
    }
    catch (e) {
      //console.log(e);
    }
  }

  public setNewData(data: LineData[], foreground: boolean) {
    let magnituderComponent = (foreground) ? "V" : "G";

    if(foreground)
    {
      //console.log("debugger")
    }
    if (data == undefined) return;

    if (!this.canCheckSignal) {

      this.lastArray = data;
      let index = this.lastArray.length - 1;

      if (this.lastArray.length < 2) return;

      let diff = this.lastArray[index].value;// - this.lastArray[index - 1].value;

      if (diff > 0) {

        this.currentState = SignalStates.BUY;
        this.lastState = SignalStates.BUY;

        if(foreground)
        {
           this.magnituderAlerts.setViolet("red",true)
        }
        else
        {
          this.magnituderAlerts.setGrey("red",true)
        }

        // if (this.isAlertActive)
        //  { this.buyAudio.play()}
      }

      if (diff < 0) {

        this.currentState = SignalStates.SELL
        this.lastState = SignalStates.SELL
        if(foreground)
        {
           this.magnituderAlerts.setViolet("green",true);
        }
        else
        {
          this.magnituderAlerts.setGrey("green",true)
        }

        // if (this.isAlertActive)
        //  { this.sellAudio.play();}
      }
      return;

    }
    else {
      this.currentArray = data;

      let index = this.currentArray.length - 1;
      let diff = this.currentArray[index].value;// - this.currentArray[index - 1].value;

      if (diff > 0) {
        this.currentState = SignalStates.BUY;


      }

      if (diff < 0) {
        this.currentState = SignalStates.SELL

      }

      if (this.lastState != this.currentState) {

        if (this.currentState == SignalStates.BUY) {
          //console.log("SIGNAL-buy" + magnituderComponent);
          if (foreground) {
            this.magnituderAlerts.setViolet("red")
            if (this.isAlertActive)
            { this.buyAudio.play()}
          }
          else {
            this.magnituderAlerts.setGrey("red")
          }

          //  if(!DGDrawingServiceGlobal.drawingService().muted)
          // if (this.isAlertActive)
          //   {this.buyAudio.play()}
        }

        if (this.currentState == SignalStates.SELL) {

          if (foreground) {
            this.magnituderAlerts.setViolet("green");
            if (this.isAlertActive)
            { this.buyAudio.play()}
          }
          else {
            this.magnituderAlerts.setGrey("green")
          }
          //console.log("SIGNAL-sell" + magnituderComponent);
          //  if(!DGDrawingServiceGlobal.drawingService().muted)
          // if (this.isAlertActive)
          //  { this.sellAudio.play();}
        }

      }

      this.lastState = this.currentState

      this.lastArray = data;
    }

  }


}


export enum SignalStates {
  BUY,
  SELL
}
